import React, { useEffect, useState } from 'react';
import { Select, Switch, Typography, Alert, Divider } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
const { Text } = Typography;
const { Option } = Select;
const defaultCompactField = { name: 'status', key: 'status' };
const IssueCardTitle = ({
  fields,
  loading,
  onCompactFieldsSelect,
  fieldSelectedCompact,
  truncateSummary,
  setTruncateSummary,
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          marginBottom: 16,
          alignItems: 'center',
        }}
      >
        <div style={{ marginRight: 8 }}>
          <Text>Title field</Text>
        </div>
        <Select
          style={{ width: 340 }}
          value={fieldSelectedCompact && fieldSelectedCompact.name}
          onSelect={onCompactFieldsSelect}
          showSearch
          loading={loading}
        >
          <Option key='status' value='status'>
            Status
          </Option>
          {Object.values(fields).map((field) => {
            return (
              <Option key={field.key} value={field.name}>
                {field.name}
              </Option>
            );
          })}
        </Select>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ marginRight: 8 }}>
          <Text>Truncate Summary to 80 characters (Max 250 characters) </Text>
        </div>
        <Switch
          checked={truncateSummary}
          onChange={() => setTruncateSummary(!truncateSummary)}
        />
      </div>
      <Divider style={{ padding: 0 }} />
      <div style={{ paddingBottom: '12px' }}>
        <Text type='secondary'>Note:</Text>
      </div>
      <Text style={{ paddingBottom: '8px' }} type='secondary'>
        <InfoCircleOutlined /> Currently supported field schema types include
        String, Array, Number, Date and User
      </Text>
    </div>
  );
};
export default IssueCardTitle;
